import { CustomerStatusType } from '../../customer/types/customerStatusType';
import { StatusType } from '../../orders/order.types';

export enum FilterGroupByEnum {
  CATEGORY = 'category',
  SUBCATEGORY = 'subcategory',
  ORDER = 'order',
  ORDER_ITEM = 'orderItem',
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
  YEAR = 'year',
  PRODUCT = 'product',
  PRODUCT_COLOR = 'productColor',
  PRODUCT_COLOR_DELIVERY_WINDOW = 'productColorDeliveryWindow',
  COLLECTION_PRODUCT = 'collectionProduct',
  COLLECTION_ORDER = 'collectionOrder',
}

export type FilterType = {
  groupBy?: FilterGroupByEnum;
  orderCode?: string;
  createdAtStartDate?: string;
  createdAtEndDate?: string;
  orderCollectionsIds?: string | string[];
  salesRepresentativeNameOrCode?: string;
  sellerName?: string;
  status?: StatusType | StatusType[];
  customerCodeOrNameOrCpfcnpj?: string;
  customerCity?: string;
  customerState?: string;
  customerStatus?: CustomerStatusType | CustomerStatusType[];
  productCodeOrName?: string;
  colorReferencesIds?: string | string[];
  deliveryWindowsIds?: string | string[];
  availability?: string | string[];
  categoriesClassification?: string | string[];
  productCollectionsIds?: string | string[];
  customerSalesRepresentativeNameOrCode?: string;
  customerIds?: string[];
  classificationsIds?: string[];
  customerClassificationIds?: string[];
  orderConditionClassificationIds?: string[];
};
